import { useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { GetSmtpGatewayView } from "../Features/Smtpgatewaysviewdata";
import { RootState, AppDispatch } from "../Appstore/store";
import { formatDate } from "../helper";
import { useNavigate } from "react-router-dom";
import { setIsLoading } from "../Features/loadingSlice";

interface SmtpGatewayRecord {
  id?: number;
  gateway_name?: string;
  client_id?: string;
  client_secret?: string;
  refresh_token?: string;
  email?: string;
  smtp_gateway?: number;
  from_email?: string;
  createdAt?: string;
  updatedAt?: string;
}

function Viewsmtpgateways() {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const { id }: any = useParams();

  const { error, smtpgatewaysviewdata, loading } = useSelector(
    (state: RootState) => state.smtpgatewaysview
  );
  const record: SmtpGatewayRecord | any = smtpgatewaysviewdata.find(
    (recodID) => recodID.id === Number(id)
  );

  useEffect(() => {
    if (id) {
      dispatch(setIsLoading(true));
      dispatch(GetSmtpGatewayView(id))
        .unwrap()
        .catch((err) => {
          console.error("Error fetching agent monitor:", err);
        })
        .finally(() => {
          setTimeout(() => dispatch(setIsLoading(false)), 500);
        });
    }
  }, [id, dispatch]);

  const navigatetobackpage = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content">
            <div className="container-fluid">
              <div className="card mt-4 shadow-sm border rounded">
                <div className="card-header bg-white p-3 d-flex justify-content-md-between">
                  <h2 className="w-100 mb-md-0 fs-3">View SMTP Gateway</h2>
                  <Link to={""} className="text-decoration-none">
                    <button
                      onClick={navigatetobackpage}
                      className="btn btn-info text-white d-flex align-items-center fw-semibold"
                    >
                      <IoMdArrowRoundBack /> Back
                    </button>
                  </Link>
                </div>

                <div className="card-body px-0 py-0">
                  <div className="table-responsive">
                    <table className="table mb-0 table-bordered">
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan={7} height={100}>
                              <div className="text-center">
                                <div className="loader"></div>
                              </div>
                            </td>
                          </tr>
                        ) : error ? (
                          <tr>
                            <td colSpan={7} height={50}>
                              <div className="text-center">
                                <p className="mb-0 fs-5 fw-semibold">
                                  No data found
                                </p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          <>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Gateway Name
                              </th>
                              <td className="p-3">{record?.gateway_name}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                SMTP Gateway
                              </th>
                              <td className="p-3">
                                {record?.smtp_gateway === 1
                                  ? "Google"
                                  : record?.smtp_gateway === 2
                                  ? "Microsoft"
                                  : ""}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Client ID
                              </th>
                              <td className="p-3">{record?.client_id}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Client Secret
                              </th>
                              <td className="p-3">{record?.client_secret}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Refresh Token
                              </th>
                              <td className="p-3">{record?.refresh_token}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                From Email
                              </th>
                              <td className="p-3">{record?.from_email}</td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Created At
                              </th>
                              <td className="p-3">
                                {formatDate(record?.createdAt)}
                              </td>
                            </tr>
                            <tr>
                              <th
                                className="p-3 fw-bold"
                                style={{ width: 150 }}
                              >
                                Updated At
                              </th>
                              <td className="p-3">
                                {formatDate(record?.updatedAt)}
                              </td>
                            </tr>
                          </>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default Viewsmtpgateways;
